// extracted by css-extract-rspack-plugin
var _1 = "center-uafwYH";
var _2 = "content-qIgV6f";
var _3 = "exit-presentation-mode-Iwnq1g";
var _4 = "exit-presentation-mode-Iwnq1g";
var _5 = "header-RdPH2p";
var _6 = "layout-xhkS_e";
var _7 = "logo-mS7OoT";
var _8 = "sider-As37uW";
var _9 = "toolbar-XUwTS0";
export { _1 as "center", _2 as "content", _3 as "exit-presentation-mode", _4 as "exitPresentationMode", _5 as "header", _6 as "layout", _7 as "logo", _8 as "sider", _9 as "toolbar" }
